import utils from '@/utils/utils.js';
import { axios, buildAuthConfig } from '@/services/apiClient';
const authorizpPofile = 'authoriz/profile/';
export default {
  config() {
    return buildAuthConfig(
      this.store &&
        this.store.state &&
        this.store.state.loginInfo &&
        this.store.state.loginInfo.accessToken
    );
  },
  store: {},
  getProfile() {
    return axios.get(this.store.state.apiUrl + authorizpPofile, this.config());
  },
  changePassword(jsonToSend) {
    return axios.post(
      this.store.state.apiUrl + 'authoriz/change-password/',
      jsonToSend,
      this.config()
    );
  },
  resetPassword(jsonToSend) {
    return axios.post(this.store.state.apiUrl + 'api/password_reset/', jsonToSend);
  },
  resetNewPassword(jsonToSend) {
    return axios.post(this.store.state.apiUrl + 'api/password_reset/confirm/', jsonToSend);
  },
  patchProfile(jsonToSend) {
    return axios.patch(this.store.state.apiUrl + authorizpPofile, jsonToSend, this.config());
  },
  deleteAccount(jsonToSend) {
    return axios.delete(this.store.state.apiUrl + authorizpPofile, {
      ...this.config(),
      data: jsonToSend,
    });
  },
  registrateProfile(jsonToSend) {
    console.log(jsonToSend, 'apiUrl');
    return axios.post(this.store.state.apiUrl + 'authoriz/registration/', jsonToSend);
  },
  patchImage(imagesData) {
    return axios.patch(
      this.store.state.apiUrl + 'authoriz/profile-images/',
      imagesData,
      this.config()
    );
  },
  authorizMyItems(apiUrl, token) {
    return axios.get(apiUrl + 'authoriz/my-items/', utils.getAuthorizeAxiosConfig(token));
  },
  authorizProfile(apiUrl, token) {
    return axios.get(apiUrl + authorizpPofile, utils.getAuthorizeAxiosConfig(token));
  },
  postApiToken(jsonToSend) {
    return axios.post(this.store.state.apiUrl + 'api/token/', jsonToSend);
  },
};
